module.exports = __webpack_public_path__ + "static/media/valor1.4c04a4d1.gif";